<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>

    <div class="box">
      <div class="left">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="indexChange(item)"
          :class="item.val == isIndex ? 'left-item active' : 'left-item'"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="right">
        <div class="DataArea">
          <div
            class="MaterialsDisplay"
            v-for="(item, index) in listArr"
            :key="index"
          >
            <img class="firm-clickable"
              src="../../../../assets/imgs/wenjian@3x.svg"
              alt=""
              @click="handelDownload(item)"
            />
            <p>{{ item.docName }}</p>
            <!-- //<div class="deleIcon firm-clickable" @click.stop="handelDeleNew(item)"></div> -->
          </div>
          <!-- <div class="Upload-box">
            <input
              type="file"
              ref="clearFile"
              @change="onFileChangeMaterials"
              id="file1"
            />
            <div class="div-icon firm-clickable" @click="clickFileMaterials(1)"></div>
          </div> -->
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  postGetStsDowLoadPath, // 生成临时下载链接
} from "../../../../assets/api/index";
import {
  getFileType, //获取系统文件库-文件类型
  getFileList, //根据文件类型获取文档列表
  insertFileForLib, //新增文件到文件库中
  deleteLibFile, //删除
} from "../../../../assets/api/firm/HumanResources";
import paging from "../../../../components/paging.vue"; // 引入分页组件
export default {
  inject: ["reload"],
  data() {
    return {
      list: [
        {
          id: 0,
          name: "公司PPT",
          val: 0,
        },
        {
          id: 1,
          name: "劳动合同附件",
          val: 3,
        },
        {
          id: 2,
          name: "职场信用评价表",
          val: 9,
        },
        {
          id: 3,
          name: "任职能力评分表",
          val: 6,
        },
        {
          id: 4,
          name: "离职申请表",
          val: 4,
        },
        {
          id: 5,
          name: "明白卡",
          val: 5,
        },
        {
          id: 6,
          name: "购销单",
          val: 2,
        },
        {
          id: 7,
          name: "表扬卡",
          val: 1,
        },
        {
          id: 8,
          name: "申请表",
          val: 7,
        },
        {
          id: 9,
          name: "员工管理资料表",
          val: 8,
        },
      ],
      isIndex: 0,
      FileName: "公司PPT", //文件名
      formInline: {
        user: "",
        region: "",
      },
      routeName: "",
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 60, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 屏蔽企业列表分页
      listArr: [],
      docId: "", //上传的文件id
      docName: "", //文件名称
    };
  },
  components: {
    paging,
  },
  created() {
    this.routeName = this.$route.name;
    this.getFileType(); //获取系统文件库-文件类型
    this.getFileList(); //根据文件类型获取文档列表
  },
  methods: {
    // ------------------ 获取系统文件库-文件类型
    async getFileType() {
      var data = {
        data: {},
      };
      // 调用 接口
      const res = await getFileType(data);
      // this.list = res.data;
    },
    // ------------------ 根据文件类型获取文档列表
    async getFileList() {
      var data = {
        data: {},
      };
      // 调用 接口
      const res = await getFileList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize,
        this.isIndex
      );
      this.pagingObj.totalDevice = res.data.total;
      this.listArr = res.data.list;
    },
    // ------------------ 新增文件到文件库中
    async insertFileForLib() {
      var data = {
        data: {
          fileType: this.isIndex,
          docId: this.docId,
          docName: this.docName,
          createBy: this.$store.getters.getUser.id,
        },
      };
      insertFileForLib(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.getFileList();
        }
      });
    },
    // // 点击上传
    // clickFileMaterials() {
    //   const input = document.querySelector("#file1");
    //   input.click();
    // },
    // // 调用上传文件/图片封装的js
    // async onFileChangeMaterials(event, opt, callback) {
    //   var file = event.target.files[0] || event.dataTransfer.files[0];
    //   var fileSuffix1 = file.name;
    //   // 文件管理模板上传上限 30M
    //   await this.$tool.onFileChange(event, Object.assign({}, opt, { maxSizeMB: 30 }), callback);
    //   setTimeout(() => {
    //     //延时获取文件上传成功后返回的docId
    //     this.docId = localStorage.getItem("docId");
    //     this.docName = localStorage.getItem("docName");

    //     this.insertFileForLib();
    //     this.$refs.clearFile.value = ""; // 清空file文件
    //   }, 1000);
    // },

    indexChange(item) {
      this.isIndex = item.val;
      this.FileName = item.name;
      this.getFileList();
    },
    // 删除文件
    // handelDeleNew(item) {
    //   var arr = [];
    //   arr[0] = item.id;
    //   var data = {
    //     data: {
    //       idList: arr,
    //     },
    //   };
    //   deleteLibFile(data).then((res) => {
    //     if (res.code == 0) {
    //       this.$tool.PromptBox("success", "操作成功");
    //       this.getFileList();
    //     }
    //   });
    // },
    // 下载文件
    handelDownload(item) {
      postGetStsDowLoadPath(item.docId).then((res) => {
        if (res.code == 0) {
          let a = document.createElement("a");
          a.href = res.data;
          a.click();
          this.$emit("handleClose", this.result);
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.getFileList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item__label {
  float: left;
}

.box {
  width: 1200px;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px 20px;
  display: flex;

  .left {
    width: 180px;
    background: #eeeeee;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;

    .left-item {
      height: 40px;
      font-size: 12px;
      background: #eeeeee;
      text-align: center;
      line-height: 40px;
      border-radius: 10px;
      margin: 10px 0;
      cursor: pointer;
    }

    .active {
      background: #fff;
    }
  }

  .right {
    flex: 1;
    margin-left: 30px;
  }
}
.DataArea {
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-wrap: wrap;
  .Upload-box {
    border: 1px dashed #409eff ;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    margin-bottom: 10px;
    margin-left: 30px;

    #file1 {
      display: none;
    }
    .div-icon {
      width: 25px;
      height: 25px;
      margin: auto;
      background-image: url("../../../../assets/imgs/tianjia@3x.svg");
      background-size: 100% 100%;
    }
    input {
      border: none;
      box-shadow: none;
      outline: none;
      background-color: transparent;
      width: 100%;
      text-align: center;
      color: #409eff ;
      margin: auto;
    }
  }
  .MaterialsDisplay:hover {
    .deleIcon {
      width: 15px;
      height: 15px;
      background-image: url("../../../../assets/imgs/shanchu@3x.svg");
      background-size: 100% 100%;
      position: absolute;
      right: 10px;
      top: 5px;
    }
    .DownloadIcon {
      width: 15px;
      height: 15px;
      background-image: url("../../../../assets/imgs/shanchu@3x.svg");
      background-size: 100% 100%;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .MaterialsDisplay {
    width: 80px;
    height: 80px;
    margin-left: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    img {
      width: 30px;
      margin: auto;
    }
    p {
      width: 100%;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #333333;
    }
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
